import React from 'react';

const AccountingContext = React.createContext();

export default AccountingContext;
